import { CourseFlatDTO } from "../domain/models/dto/CourseDTO";
import { ICourseFlat } from "../domain/models/Course";
import { CourseFlatModel } from "../models/CourseFlatModel";
import { SimpleMapper } from "./SimpleMapper";

export class CourseFlatMapper extends SimpleMapper<ICourseFlat, CourseFlatDTO> {
    protected toDTOFields: string[] = [
        "id",
        "files",
        "title",
        "shortContent",
        "description",
        "author",
        "duration",
        "topic",
        "imageUrl",
        "languageCode",
        "creatorId",
        "createdAt",
        "updatedAt",
        "updatorId",
    ];

    protected fromDTOFields: string[] = [...this.toDTOFields];

    fromDTO(dto: CourseFlatDTO): ICourseFlat {
        if (!dto) return null;

        return new CourseFlatModel(dto);
    }
}
